import styled from "styled-components";

export const ImplinksCss = styled.div`
  width: 95.4vw;

  .implinks {
    min-height: 45px;
    width: 97%;
    border-top: 1px solid #f0f0f0;
    position: relative;
    top: 1rem;
    left: 4rem;
    display: flex;
    div {
      margin-left: 2rem;
    }

    a {
      text-decoration: none;
      color: rgb(127, 127, 127);
      font-weight: bold;
    }
  }
`;
